import { Outlet } from 'react-router-dom'

import ReportsRoot, { RenderProps } from 'modules/reports/components/ReportsRoot'
import CollectionsBootstrap from 'modules/reports/lib/CollectionsBootstrap'

const Container = () => {
  return (
    <ReportsRoot>
      {({ back, loading }: RenderProps) => <Outlet context={{ back, loading }} />}
    </ReportsRoot>
  )
}

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <Container />
    </CollectionsBootstrap>
  )
}

export default RootPage
